import { Box, IconButton } from '@mui/material';

import ProfileMenu from '../ProfileMenu';
import {
  AVATAR_IMAGE_STYLE,
  FALLBACK_AVATAR_SX,
  PROFILE_BUTTON_SX,
} from '../styles';

import type { ProfileAvatarButtonProps } from '../types';

export default function ProfileAvatarButton({
  anchorEl,
  onClick,
  onClose,
  open,
  user,
}: ProfileAvatarButtonProps) {
  return (
    <>
      <IconButton
        id="avatar-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={onClick}
        sx={PROFILE_BUTTON_SX}
        data-testid="profileIconId"
      >
        {user?.picture ? (
          <img src={user.picture} alt="avatar" style={AVATAR_IMAGE_STYLE} />
        ) : (
          <Box sx={FALLBACK_AVATAR_SX} />
        )}
      </IconButton>
      <ProfileMenu user={user} open={open} anchorEl={anchorEl} onClose={onClose} />
    </>
  );
}
